$shm_hitalama_app_book $mol_book2_catalog
	maps_list_visible? true
	projects_list_visible? true
	menu_item_content* /$mol_view
		<= Menu_link*
		^ maps_list_toggle_visible* / <= Maps_list_toggle* $mol_check_icon
			hint \Показать/скрыть список карт
			checked? <=> maps_list_visible?
			Icon <= Maps_list_toggle_icon* $mol_icon_format_list_bulleted
		^ projects_list_toggle_visible* / <= Projects_list_toggle* $mol_check_icon
			hint \Показать/скрыть список проектов
			checked? <=> projects_list_visible?
			Icon <= Projects_list_toggle_icon* $mol_icon_format_list_bulleted
	menu_body /$mol_view
		<= Menu_links
		<= Foot_profile_card $mol_view
			sub /
				<= Foot_profile $shm_hitalama_profile_switch
					align \top_center
